export default class {
  id: string;

  title: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.title = obj.title || '';
  }
}
